module.exports = __webpack_public_path__ + "static/media/mana-sphere.8479b228.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mana-sphere.png
// module id = 126
// module chunks = 48